import { createSlice } from '@reduxjs/toolkit';

export const App = createSlice({
	name: 'app',
	initialState: {
		firstEyeImageTemp: null,
		secondEyeImageTemp: null,
	},
	reducers: {
		firstEyeImageTempFiller: (state, actions) => {
			state.firstEyeImageTemp = actions.payload;
		},
		secondEyeImageTempFiller: (state, actions) => {
			state.secondEyeImageTemp = actions.payload;
		},
	},
});

export const { firstEyeImageTempFiller, secondEyeImageTempFiller } = App.actions;

export default App.reducer;
